
import React, { Fragment } from 'react'
import { Button, Col, ListGroup, Modal, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'

import UserOption from './UserOption'

import AddICon from '../../../SvgImages/Add'

import './TeamMemberSelector.scss'

interface Props {
  subTask?: any
  onSelect: (user: any) => void
}

const TeamMemberSelector = ({ subTask, onSelect }: Props) => {

  const [ showModal, setShowModal ] = React.useState(false)

  const { users } = useSelector((state: any) => state.ProgrammationReducer)

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className='mb-2'
      >
        <AddICon fill="#fff" height={24} width={24} />
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdropClassName='team-member-selector-backdrop'
        className='team-member-selector'
      >
        <Modal.Header>
          <Modal.Title>
            Assign a responsible
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <ListGroup>
                {users.map((r: any, i: number) => (
                  <UserOption
                    key={i}
                    subTask={subTask}
                    user={r}
                  />
                ))}
              </ListGroup>

            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default TeamMemberSelector
